import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getReferenceDetailsUrl } from "../utils/urlHelper";

const referenceDetailsApi = createApi({
  reducerPath: "referenceDetails",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    referenceDetails: builder.mutation({
      query: (body) => ({
        url: getReferenceDetailsUrl(),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useReferenceDetailsMutation } = referenceDetailsApi;

export { referenceDetailsApi };
